import { Can } from 'providers/casl'
import {
  onAdUnitCreateUpdateDelete,
  onAdUnitFieldsRead,
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning,
} from '../features/adUnit'
import {
  onDomainCustomBranchAlertRead,
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead,
  onDomainUnfilledRecoveryBaseAdUnitPathRead,
  onDomainUnfilledRecoveryReadPrebidSettingsWarning,
} from '../features/domain'
import {
  onGlobalSetupPriceGeniusRead,
  onGlobalSetupWorkspaceUpdate,
} from '../features/globalSetup/common'
import { onGlobalSetupDefaultsPrebidVariableNameRead } from '../features/globalSetup/defaults'
import { onPerformanceAdminOptionReadUpdate } from '../features/performance'
import { onProductStatusReadUpdate, onProductUpdate } from '../features/product'
import { onUserAccess } from '../features/user'
import { onWorkspaceAccess } from '../features/workspace'

export const onEmployeesOnly = (can: Can) => {
  onAdUnitCreateUpdateDelete(can)
  onAdUnitFieldsRead(can)
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning(can)
  onDomainCustomBranchAlertRead(can)
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead(can)
  onDomainUnfilledRecoveryBaseAdUnitPathRead(can)
  onDomainUnfilledRecoveryReadPrebidSettingsWarning(can)
  onGlobalSetupDefaultsPrebidVariableNameRead(can)
  onGlobalSetupPriceGeniusRead(can)
  onGlobalSetupWorkspaceUpdate(can)
  onPerformanceAdminOptionReadUpdate(can)
  onProductStatusReadUpdate(can)
  onProductUpdate(can)
  onUserAccess(can)
  onWorkspaceAccess(can)
}
